import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IdbService } from '../idb/idb.service';
import Swal, { SweetAlertInput } from 'sweetalert2';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { environment } from '../../../environments/environment';
import moment from 'moment';
moment.locale('fr');
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  local_storage_prefixe = "africarent.angular";
  taf_base_url = environment.taf_base_url;
  files_base_url = environment.files_base_url;
  network: any = {
    token: undefined,
    status: true,
    message: "Aucun probléme détecté",
  }
  token: any = {
    token_key: null,
    token_decoded: null,
    user_connected: null,
    is_expired: null,
    date_expiration: null
  }

  constructor(private http: HttpClient, private route: Router, private idb: IdbService) { }
  // sauvegardes
  async get_from_local_storage(key: string): Promise<any> {
    try {
      let res: any = await this.idb.get_from_indexedDB(key)
      return res
    } catch (error) {
      console.error("erreur de recuperation", error)
      return null
    }
  }
  menu: any[] = []
  les_droits_utilisateur: any[] = []
  full_menu: any[] = [
    {
      text: "Tableau de bord",
      path: "/home/dashboard",
      icone: "bi bi-speedometer2",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Tableau de bord", id: "/home/dashboard", action: "Voir le tableau de bord" },
      ]
    },
    {
      text: "Reservations",
      path: "/home/location",
      icone: "bi bi-journal-check",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Reservations", id: "add_location", action: "Ajouter une réservation" },
        { ongle: "Reservations", id: "edit_location", action: "Editer une réservation" },
        { ongle: "Reservations", id: "/home/location", action: "Detail d'une réservation" },
        { ongle: "Reservations", id: "list_location", action: "Lister les réservations" },
        { ongle: "Reservations", id: "search_location", action: "Recherche une réservation" },
      ],
    },
    {
      text: "Véhicules",
      path: "/home/vehicule",
      icone: "bi bi-car-front-fill",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Véhicules", id: "add_vehicule", action: "Ajouter un véhicule" },
        { ongle: "Véhicules", id: "edit_vehicule", action: "Editer un véhicule" },
        { ongle: "Véhicules", id: "/home/vehicule", action: "Detail d'un véhicule" },
        { ongle: "Véhicules", id: "list_vehicule", action: "Lister les véhicules" },
        { ongle: "Véhicules", id: "search_vehicule", action: "Recherche un véhicule" },
      ],
    },
    {
      text: "Clients",
      path: "/home/client",
      icone: "bi bi-people-fill",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Clients", id: "add_client", action: "Ajouter un client" },
        { ongle: "Clients", id: "edit_client", action: "Editer un client" },
        { ongle: "Clients", id: "/home/utilisateur", action: "Detail d'un client" },
        { ongle: "Clients", id: "list_client", action: "Lister les categories" },
        { ongle: "Clients", id: "search_client", action: "Recherche un client" },
      ],
    },
    {
      text: "Partenaires",
      path: "/home/partenaire",
      icone: "bi bi-people-fill",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Partenaires", id: "add_partenaire", action: "Ajouter un partenaire" },
        { ongle: "Partenaires", id: "edit_partenaire", action: "Editer un partenaire" },
        { ongle: "Partenaires", id: "/home/partenaire", action: "Detail d'un partenaire" },
        { ongle: "Partenaires", id: "list_partenaire", action: "Lister les partenaires" },
        { ongle: "Partenaires", id: "search_partenaire", action: "Recherche un partenaire" },
      ],
    },
    {
      text: "Configuration",
      path: "/home/configuration",
      icone: "bi bi-gear",
      les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
      children: [
        {
          text: "Utilisateurs",
          path: "/home/configuration/utilisateur",
          icone: "bi bi-person-badge-fill",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "Utilisateurs", id: "add_utilisateur", action: "Ajouter un utilisateur" },
            { ongle: "Utilisateurs", id: "edit_utilisateur", action: "Editer un utilisateur" },
            { ongle: "Utilisateurs", id: "/home/admin_utilisateur", action: "Detail d'un utilisateur" },
            { ongle: "Utilisateurs", id: "list_utilisateur", action: "Lister les utilisateurs" },
            { ongle: "Utilisateurs", id: "search_utilisateur", action: "Recherche un utilisateur" },
          ],
        },
        {
          text: "Privilège",
          icone: "bi bi-shield-lock-fill",
          path: "/home/configuration/privilege",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "Privilege", id: "add_privilege", action: "Ajouter un privilège" },
            { ongle: "Privilege", id: "edit_privilege", action: "Modifier un privilège" },
            { ongle: "Privilege", id: "list_privilege", action: "Lister les privilèges" },
            { ongle: "Privilege", id: "search_privilege", action: "Rechercher un privilège" },
          ],
        },
        // {
        //   text: "Critères d’éligibilité",
        //   path: "/home/configuration/critere_eligibilite",
        //   icone: "bi bi-person-badge-fill",
        //   les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
        //   les_actions: [
        //     { ongle: "Critere", id: "add_critere", action: "Ajouter un critère" },
        //     { ongle: "Critere", id: "edit_critere", action: "Modifier un critère" },
        //     { ongle: "Critere", id: "list_critere", action: "Lister les critères" },
        //     { ongle: "Critere", id: "search_critere", action: "Rechercher un critère" },
        //   ],
        // },
        {
          text: "État location",
          path: "/home/configuration/etat_location",
          icone: "bi bi-geo-alt-fill",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "EtatLocation", id: "add_etat_location", action: "Ajouter un état location" },
            { ongle: "EtatLocation", id: "edit_etat_location", action: "Modifier un état location" },
            { ongle: "EtatLocation", id: "list_etat_location", action: "Lister les états location" },
            { ongle: "EtatLocation", id: "search_etat_location", action: "Rechercher un état location" },
          ],
        },
        {
          text: "État des véhicules",
          path: "/home/configuration/etat_vehicule",
          icone: "bi bi-truck",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "EtatVehicule", id: "add_etat_vehicule", action: "Ajouter un état de véhicule" },
            { ongle: "EtatVehicule", id: "edit_etat_vehicule", action: "Modifier un état de véhicule" },
            { ongle: "EtatVehicule", id: "list_etat_vehicule", action: "Lister les états de véhicule" },
            { ongle: "EtatVehicule", id: "search_etat_vehicule", action: "Rechercher un état de véhicule" },
          ],
        },
        {
          text: "Marque",
          icone: "bi bi-tags-fill",
          path: "/home/configuration/marque",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "Marque", id: "add_marque", action: "Ajouter une marque" },
            { ongle: "Marque", id: "edit_marque", action: "Modifier une marque" },
            { ongle: "Marque", id: "list_marque", action: "Lister les marques" },
            { ongle: "Marque", id: "search_marque", action: "Rechercher une marque" },
          ],
        },{
          text: "Modele",
          icone: "bi bi-box",
          path: "/home/configuration/modele",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "Modele", id: "add_modele", action: "Ajouter une modele" },
            { ongle: "Modele", id: "edit_modele", action: "Modifier une modele" },
            { ongle: "Modele", id: "list_modele", action: "Lister les modeles" },
            { ongle: "Modele", id: "search_modele", action: "Rechercher une modele" },
          ],
        },
        {
          text: "Mode de paiement",
          path: "/home/configuration/mode_paiement",
          icone: "bi bi-credit-card-2-front-fill",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "ModePaiement", id: "add_mode_paiement", action: "Ajouter un mode de paiement" },
            { ongle: "ModePaiement", id: "edit_mode_paiement", action: "Modifier un mode de paiement" },
            { ongle: "ModePaiement", id: "list_mode_paiement", action: "Lister les modes de paiement" },
            { ongle: "ModePaiement", id: "search_mode_paiement", action: "Rechercher un mode de paiement" },
          ],
        },
        {
          text: "Type de pièce",
          icone: "bi bi-file-earmark-person-fill",
          path: "/home/configuration/type_piece",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "TypePiece", id: "add_type_piece", action: "Ajouter un type de pièce" },
            { ongle: "TypePiece", id: "edit_type_piece", action: "Modifier un type de pièce" },
            { ongle: "TypePiece", id: "list_type_piece", action: "Lister les types de pièce" },
            { ongle: "TypePiece", id: "search_type_piece", action: "Rechercher un type de pièce" },
          ],
        },
        {
          text: "Type de tarif",
          path: "/home/configuration/type_tarif",
          icone: "bi bi-cash-coin",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "TypeTarif", id: "add_type_tarif", action: "Ajouter un type de tarif" },
            { ongle: "TypeTarif", id: "edit_type_tarif", action: "Modifier un type de tarif" },
            { ongle: "TypeTarif", id: "list_type_tarif", action: "Lister les types de tarif" },
            { ongle: "TypeTarif", id: "search_type_tarif", action: "Rechercher un type de tarif" },
          ],
        },
        {
          text: "Zone",
          icone: "bi bi-map-fill",
          path: "/home/configuration/zone",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "Zone", id: "add_zone", action: "Ajouter une zone" },
            { ongle: "Zone", id: "edit_zone", action: "Modifier une zone" },
            { ongle: "Zone", id: "list_zone", action: "Lister les zones" },
            { ongle: "Zone", id: "search_zone", action: "Rechercher une zone" },
          ],
        },
        {
          text: "Options incluses",
          icone: "bi bi-list-check",
          path: "/home/configuration/option_incluse",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "OptionEtatLocation", id: "add_option_etat_location", action: "Ajouter une option" },
            { ongle: "OptionEtatLocation", id: "edit_option_etat_location", action: "Modifier une option" },
            { ongle: "OptionEtatLocation", id: "list_option_etat_location", action: "Lister les options" },
            { ongle: "OptionEtatLocation", id: "search_option_etat_location", action: "Rechercher une option" },
          ],
        },
        {
          text: "Type de véhicule",
          icone: "bi bi-car-front-fill",
          path: "/home/configuration/type_vehicule",
          les_droits: { voir: false, modifier: false, ajouter: false, supprimer: false },
          les_actions: [
            { ongle: "TypeVehicule", id: "add_type_vehicule", action: "Ajouter un type de véhicule" },
            { ongle: "TypeVehicule", id: "edit_type_vehicule", action: "Modifier un type de véhicule" },
            { ongle: "TypeVehicule", id: "list_type_vehicule", action: "Lister les types de véhicule" },
            { ongle: "TypeVehicule", id: "search_type_vehicule", action: "Rechercher un type de véhicule" },
          ],
        },
      ]
    },
    {
      text: "Mon profil",
      path: "/home/profile",
      icone: "bi bi-person-circle",
      les_droits: { voir: true, modifier: true, ajouter: false, supprimer: false },
      les_actions: [
        { ongle: "Mon profil", id: "/home/profile", action: "Voir mon profil" },
        { ongle: "Mon profil", id: "edit_profile", action: "Modifier mon profil" },
      ]
    }
  ];
  async save_on_local_storage(key: string, value: any): Promise<void> {
    await this.idb.save_on_indexedDB(key, value);
  }
  async delete_from_local_storage(key: string) {
    await this.idb.delete_from_indexedDB(key);
  }

  async get_token() {
    //le token n'est pas encore chargé
    if (this.network.token == undefined) {
      this.network.token = await this.get_from_local_storage("token")
      if (this.network.token != undefined && this.network.token != null) {// token existant
        this.update_data_from_token()// mise a jour du token
      }
    } else {// token dèja chargé
      this.update_data_from_token()// mise a jour du token
    }
    return this.network.token
  }
  //les requetes http
  async taf_get(path: string, on_success: Function, on_error: Function) {
    let api_url = this.taf_base_url + path;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + await this.get_token(),
      })
    };

    this.http.get(api_url, httpOptions).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_get_error(error, on_error)
      }
    )
  }
  on_taf_get_error(error: any, on_error: Function) {
    this.network.status = false;
    this.network.message = error
    this.Swal_info("Merci de vérifier votre connexion")
    on_error(error)
  }
  async taf_post(path: string, data_to_send: any, on_success: Function, on_error: Function) {
    let api_url = this.taf_base_url + path;
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + await this.get_token(),
      })
    };
    this.http.post(api_url, data_to_send, httpOptions).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_post_error(error, on_error)
      }
    )
  }
  async taf_post_login(path: string, data_to_send: any, on_success: Function, on_error: Function) {
    let api_url = this.taf_base_url + path;

    this.http.post(api_url, data_to_send).subscribe(
      (reponse: any) => {// on success
        on_success(reponse)
      },
      (error: any) => {// on error
        this.on_taf_post_error(error, on_error)
      }
    )
  }
  on_taf_post_error(error: any, on_error: any) {
    this.network.status = false;
    this.network.message = error
    this.Swal_info("Merci de vérifier votre connexion")
    on_error(error)
  }
  async update_data_from_token() {
    let token_key = await this.get_from_local_storage("token")
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(token_key);
    const expirationDate = helper.getTokenExpirationDate(token_key);
    const isExpired = helper.isTokenExpired(token_key);

    this.token = {
      token_key: token_key,
      token_decoded: decodedToken,
      user_connected: decodedToken.taf_data,
      is_expired: isExpired,
      date_expiration: expirationDate
    }
    if (this.token.is_expired) {
      this.on_token_expire()
    }
    this.custom_menu()
  }
  on_token_expire() {
    this.Swal_info("Votre session s'est expiré! Veuillez vous connecter à nouveau")
    this.delete_from_local_storage("token")
    this.route.navigate(['/public/login'])
  }
  Swal_success(title: any) {
    let succes2 = Notify.success(title);
    return succes2
  }

  Swal_error(title: any) {
    let error2 = Notify.failure(title)
    return error2
  }
  Swal_info(title: any) {
    let info2 = Notify.info(title)
    return info2
  }
  async custom_menu() {
    let les_actions: any = await this.get_from_local_storage("les_actions");
    if (!les_actions) {
      this.menu = [];
      return;
    }

    try {
      this.les_droits_utilisateur = Array.isArray(les_actions.action)
        ? les_actions.action
        : JSON.parse(les_actions.action || "[]");
    } catch {
      this.les_droits_utilisateur = [];
    }
    // Si l'utilisateur est client, remplacer "Tableau de bord" par "Accueil"
if (this.token?.user_connected?.id_privilege == 3) {
  const indexDashboard = this.full_menu.findIndex(item => item.text === "Tableau de bord");
  if (indexDashboard !== -1) {
    this.full_menu[indexDashboard].text = "Accueil";
    this.full_menu[indexDashboard].les_actions = [
      { ongle: "Accueil", id: "/home/dashboard", action: "Voir l'accueil" }
    ];
  }
}
    // Fonction récursive pour filtrer menus et sous-menus
    const filtrer_menu = (menu_items: any[]) => {
      return menu_items
        .map((item) => {
          let nouveau = { ...item };

          // Filtrer les actions
          if (nouveau.les_actions?.length > 0) {
            nouveau.les_actions = item.les_actions.filter((action: any) =>
              this.can(action.id)
            );
          }
          if (nouveau.children?.length > 0) {
            nouveau.children = filtrer_menu(item.children);
          }
          const visible =
            (nouveau.les_actions && nouveau.les_actions.length > 0) ||
            (nouveau.children && nouveau.children.length > 0);

          return visible ? nouveau : null;
        })
        .filter(Boolean);
    };
    this.menu = filtrer_menu(this.full_menu);


    // console.log("Menu final filtré :", this.menu);
  }

  can(id: string) {
    if (this.token?.user_connected?.id_privilege == 1) return true; // admin
    if (!id || !this.les_droits_utilisateur?.length) return false;
    return this.les_droits_utilisateur.some((a: any) => {
      const aid = String(a.id || "").toLowerCase();
      const bid = String(id || "").toLowerCase();
      return aid === bid || aid.includes(bid) || bid.includes(aid);
    });
  }

  deconnexion() {
    this.delete_from_local_storage("token")

    this.network = {
      token: undefined,
      status: true,
      message: "Aucun probléme détecté",
    }
    this.token = {
      token_key: null,
      token_decoded: null,
      user_connected: null,
      is_expired: null,
      date_expiration: null
    }
    this.route.navigate(['/'])
  }
  Swal_confirm(titre: string, texte: string, callback: Function) {
    Swal.fire({
      title: titre,
      text: texte,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui, confirmer",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) callback();
    });
  }

  Swal_input(titre: string, texte: string, type: SweetAlertInput, callback: Function,defaultValue = "") {
    Swal.fire({
      title: titre,
      text: texte,
      input: type,
      inputValue: defaultValue,
      inputPlaceholder: "Ex: Le client n’a pas respecté les conditions...",
      showCancelButton: true,
      confirmButtonText: "Soumettre",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#dc3545",
      inputValidator: (value: any) => {
        if (!value) return "Veuillez saisir un motif";
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        callback(result.value);
      }
    });
  }
}
